import { DataSrc } from '../mlmodel/mlModel-parameters.model';
import { Model } from "./Model.model";


export class ParameterModel {
  model: Model; 
  parameterId;
  dataSource: DataSrc;
  dataSourceId;
  srcFrequency;
  srcParameterId;
  srcParameterName;
  srcParameterUoM;
  defaultValue;

  constructor() {
    // CONSTRUCTOR IS EMPTY
  }
}